import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import CookieConsent from "react-cookie-consent"
import { useScrollData } from "scroll-data-hook"
import styled from "styled-components"
import "./layout.css"
import "@fontsource/open-sans/300.css"
import "@fontsource/open-sans/400.css"
import "@fontsource/open-sans/600.css"
import "@fontsource/open-sans/700.css"
import Navigation from "./layoutComponents/navigation"
import Footer from "./layoutComponents/Footer"
import { fontBold, fontRegular } from "../utils/fontFamily"
import SEO from "./seo"
import useScript from "../utils/hooks/useScript"

const Layout = ({ seo, header, main, currentPath, children }) => {
  const [stickySubNav, setStickySubNav] = useState(false)

  const { position } = useScrollData()
  useScript("//fast.appcues.com/36511.js", true)

  useEffect(() => {
    setStickySubNav(position)

    if (position && position.y > 40) {
      setStickySubNav(true)
    } else if (position && position.y < 40) {
      setStickySubNav(false)
    }
  }, [position])

  return (
    <>
      <SEO
        title={seo.title && seo.title}
        description={seo.description && seo.description}
      />
      <Navigation
        currentPath={currentPath}
        setStickySubNav={setStickySubNav}
        stickySubNav={stickySubNav}
      />
      {header}
      {/* <main
        style={{
          paddingTop: stickySubNav ? "134px" : 0,
          position: stickySubNav ? "relative" : "",
        }}
      > */}
      <main>
        {main}
        {children}
      </main>
      <Footer />
      <MindMeCookieConsentStyles>
        <CookieConsent
          containerClasses="container"
          buttonClasses="button"
          buttonText="Continue"
        >
          MindMe uses cookies to enhance your user experience. By using the
          website, you consent to our{" "}
          <Link to="/privacy-policy/">Privacy Policy.</Link>
        </CookieConsent>
      </MindMeCookieConsentStyles>
    </>
  )
}

Layout.propTypes = {
  header: PropTypes.node,
  main: PropTypes.node,
}

Layout.defaultProps = {
  header: null,
}

export default Layout

const MindMeCookieConsentStyles = styled.div`
  & .container {
    ${fontRegular()}
    background: #FFEFEF !important;
    color: #333 !important;
    border-top: 1px solid #dddddd;
  }

  & .button {
    background: #58ac2e !important;
    color: #fff !important;
    border-radius: 50px !important;
    padding: 10px 20px !important;
    ${fontBold()}
    font-size: 16px !important;
  }
`
